/**
 * Typed bindings for /admin/sectors (PR #5g).
 *
 * All methods require `admin.sectors.manage`.
 */

import { z } from 'zod';

import {
  SectorListResponseSchema,
  SectorSchema,
  type SectorDto,
  type SectorListResponse,
  type UpsertSectorBody,
} from '../schemas/sector.js';
import type { RequestOptions, Transport } from './transport.js';

export interface SectorClient {
  list(options?: RequestOptions): Promise<SectorListResponse>;
  upsert(
    id: string | undefined,
    body: UpsertSectorBody,
    options?: RequestOptions,
  ): Promise<SectorDto>;
  remove(id: string, options?: RequestOptions): Promise<void>;
}

export const createSectorClient = (transport: Transport): SectorClient => ({
  list: (options) => transport.get('/admin/sectors', SectorListResponseSchema, options),

  upsert: (id, body, options) => {
    if (id === undefined) {
      return transport.post('/admin/sectors', SectorSchema, body, options);
    }
    return transport.put(`/admin/sectors/${id}`, SectorSchema, body, options);
  },

  remove: async (id, options) => {
    await transport.delete(`/admin/sectors/${id}`, z.null(), options);
  },
});
